import { useSnapshot } from 'valtio'
import React, { type ReactElement } from 'react'
import cn from 'classnames'
import { ErrorDisplay } from '../../../shared/components/ui/forms/ErrorDisplay'
import { DeterminePrimaryColorIconPoweredBy } from '../../../shared/themes/logoFunctions'
import { proxyGlobalAuth } from '../../../shared/proxies/proxyGlobalAuth'
import Spinner from '../../../shared/components/ui/Spinner'
import UserIcon from '../../../shared/components/ui/icons/UserIcon'
import { StandardIconInput } from '../../../shared/components/ui/forms/StandardIconInput'
import { handleBlur, handleChange, handleFormSubmit } from './utils/utils'
import { FormFieldNamesEnum } from './utils/formFieldNamesEnum'
import { proxyRequestMerchants } from './proxyRequestMerchants'

export function RequestMerchantsForm (): ReactElement {
  const { allowSubmit, apiCallRequestMerchant: { error, loading }, showEmailError, formErrors, formValues } = useSnapshot(proxyRequestMerchants)
  const { siteDomainEnum, siteTheme: { buttonColors } } = useSnapshot(proxyGlobalAuth)

  return (
    <form onSubmit={handleFormSubmit} className="flex flex-col justify-center items-center">
      {
        error &&
        (
          <div className="mb-4">
            <ErrorDisplay error={error} />
          </div>
        )
      }

      <div className="w-72">
        <DeterminePrimaryColorIconPoweredBy theme={siteDomainEnum} />
        <p className="text-lg text-center my-8">
          Request Merchant Account Ids
        </p>
        <StandardIconInput
          id="email"
          onChange={handleChange(FormFieldNamesEnum.Email)}
          onBlur={handleBlur(FormFieldNamesEnum.Email)}
          placeholder="Email"
          icon={UserIcon}
          errorMessage={formErrors[FormFieldNamesEnum.Email] ?? ''}
          showError={showEmailError}
          value={formValues[FormFieldNamesEnum.Email] ?? ''}
        />

        <button
          type="submit"
          className={
              cn(
                buttonColors.classes, 'text-white w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium focus:ring-2 focus:ring-offset-2')
            }
          disabled={!allowSubmit}
        >
          {
            loading
              ? (<Spinner additionalClasses="-ml-1 mr-3" />)
              : 'Submit'
          }
        </button>
      </div>
    </form>
  )
}
